import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';

import { CoachContext } from '../context/coach';
import { useContext, useEffect, useMemo, useState } from 'react';

//material-ui
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import VerifiedIcon from '@material-ui/icons/VerifiedUser';
import DollarIcon from '@material-ui/icons/AttachMoney';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ClearIcon from '@material-ui/icons/Clear';
import FilterIcon from '@material-ui/icons/FilterList';
import { Loading, PaginatedTable, TBD } from '../common/variables';
import { AppContext } from '../context/app';
import { Badge, IconButton } from '@material-ui/core';

export function Coaches(){
    const { coachState : {coaches} , getCoaches , UpdateCoach , removeCoach} = useContext(CoachContext);
    const { showAppToast , hideAppToast} = useContext(AppContext);
    const [perPage , setPerPage] = useState(10);
    const [loading , setLoading] = useState(true);
    const [selectingFilters , setSelectingFilters] = useState(false);
    const [filter ,setFilter] = useState({});
    const [validatingDelete , setValidatingDelete] = useState(false);
    const [coachToDelete , setCoachToDelete] = useState(null);

    useEffect(()=>{
      try{
        getCoaches();
      }
      finally{
        setTimeout(()=>setLoading(false) ,1000);
      }
    },[]);
    async function handleCoachesRefresh(){
      try{
        setLoading(true);
        getCoaches();
      }
      finally{
        setTimeout(()=>setLoading(false) ,1000);
      }
    }
    const filtered_coaches = useMemo(()=>{
      if(Object.keys(filter).length === 0){
        return coaches;
      }
      return coaches.filter((coach)=>{
        let expr = true;
        for(const key in filter){
          if(key==="club"){
            expr = expr && coach.club.name.toLowerCase().startsWith(filter[key].toLowerCase());
            continue;
          }
          if((key==="fees_paid") || (key=== "aab_verified")){
            expr = expr && (coach[key] && (coach[key] === JSON.parse(filter[key])) || (!coach[key] && !JSON.parse(filter[key])));
            continue;
          }
          expr = expr && coach[key].toLowerCase().startsWith(filter[key].toLowerCase());
        }
        return expr;
      });
    },[filter,coaches]);
    const handleVerifyClicked = async (id)=>{
        try{
          await UpdateCoach({id , aab_verified : true});
          await getCoaches();
          showAppToast("Coach has been successfully verified.","success");
        }
        catch(err){
          console.log(err);
          showAppToast("Unable to verify Coach. Try again later.","danger");
        }
        finally{
          setTimeout(()=>{
            hideAppToast();
          },2000);
        }
    };
    const handleUnVerifyClicked = async (id)=>{
        try{
          await UpdateCoach({id , aab_verified : false});
          await getCoaches();
          showAppToast("Coach has been unverified.","success");
        }
        catch(err){
          showAppToast("Unable to unverify Coach. Try again later.","danger");
          console.log(err);
        }
        finally{
          setTimeout(()=>{
            hideAppToast();
          },2000);
        }
    };
    const handlePayFeesClicked = async (id)=>{
        try{
          await UpdateCoach({id , fees_paid : true});
          await getCoaches();
          showAppToast("Coach payment status successfully updated.","success");
        }
        catch(err){
          console.log(err);
          showAppToast("Unable to update coach payment status.","danger");
        }
        finally{
          setTimeout(()=>{
            hideAppToast();
          },2000);
        }
    };
    const handleUnpayFeesClicked = async (id)=>{
        try{
          await UpdateCoach({id , fees_paid : false});
          await getCoaches();
          showAppToast("Coach payment status successfully updated.","success");
        }
        catch(err){
          console.log(err);
          showAppToast("Unable to update coach payment status.","danger");
        }
        finally{
          setTimeout(()=>{
            hideAppToast();
          },2000);
        }
    };
    const FilterSelectRow = ()=>{
      return(
        <Table>
          <tbody style={{marginBottom : 4}}>
          <tr>
            <td style={{width : 20}}></td>
            <td style={{width : 125}}><Form.Control placeholder="Filter ID" type="text" value={filter.id} onChange={(e)=>setFilter({ ...filter ,"id" : e.target.value})}/></td>
            <td style={{width : 125}}><Form.Control placeholder="Filter first name" type="text" value={filter.first_name} onChange={(e)=>setFilter({ ...filter ,"first_name" : e.target.value})}/></td>
            <td style={{width : 125}}><Form.Control placeholder="Filter last name" type="text" value={filter.last_name} onChange={(e)=>setFilter({ ...filter ,"last_name" : e.target.value})}/></td>
            <td style={{width : 200}}><Form.Control placeholder="Filter email" type="text" value={filter.email} onChange={(e)=>setFilter({ ...filter ,"email" : e.target.value})}/></td>
            <td style={{width : 200}}><Form.Control placeholder="Filter club" type="text" value={filter.club} onChange={(e)=>setFilter({ ...filter ,"club" : e.target.value})}/></td>
            <td style={{width : 200}}>
                <Form.Control  as="select" onChange={(e)=>setFilter({ ...filter ,"fees_paid" : e.target.value})}  value={filter.fees_paid} >
                  <option value={null}>-- Verification --</option>
                  <option value={true}>Verified</option>
                  <option value={false}>Verified required</option>
                </Form.Control>
            </td>
            <td style={{width : 125}}>
                <Form.Control  as="select" onChange={(e)=>setFilter({ ...filter ,"aab_verified" : e.target.value})} value={filter.aab_verified}>
                  <option value={null}>-- Fee Status --</option>
                  <option value={false}>Due</option>
                  <option value={true}>Paid In Full</option>
                </Form.Control>
            </td>
          </tr>
        </tbody>
        </Table>
        
      )
    }
    async function handleCoachDelete(){
      try{
        await removeCoach({id : coachToDelete.id});
        showAppToast(`${coachToDelete.name} deleted`,"success");
      }
      catch(err){
        showAppToast(`Error when deleting ${coachToDelete.name}`,"error");
        console.log(err);
      }
      finally{
        getCoaches();
        setTimeout(()=>hideAppToast(),1000);
        setValidatingDelete(false);
      }
    }
    return(
      <div className="mr-2 p-2 d-flex flex-column">
        <div className="d-flex mb-1 justify-content-between">
            <h4>Coaches</h4>
            <div className="d-flex align-items-center">
                <>
                  {Object.keys(filter).length !== 0 &&<IconButton disabled={Object.keys(filter).length === 0} style={{marginRight : 2 ,outline:"none" , padding : 1}} className="text-danger" onClick={()=>setFilter({})}><ClearIcon/></IconButton>}
                    {
                      <>
                          <IconButton style={{marginRight : 1 ,outline:"none" , position : "relative" , padding : 1}} onClick={()=>setSelectingFilters(!selectingFilters)}>
                          <FilterIcon/>
                          { Object.keys(filter).length !== 0 && <Badge className="bg-info" style={{width :10 , height : 10 , borderRadius : "50%" , position : "absolute" , top: 0 , right : 0 , }}/>}
                        </IconButton>
                        <p style={{fontSize : "70%" , marginBottom : 0 , marginLeft : 1 ,marginRight : 8 }}>Filter</p>
                      </>
                    }
                </>
              <Form.Control  style={{width : 100 , marginRight : 4}} as="select" value={perPage} onChange={(e)=>setPerPage(e.target.value)}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
              </Form.Control>
                <Button size="sm" variant="outline-success"><RefreshIcon onClick={handleCoachesRefresh} /></Button>
            </div>
        </div>
        {
          loading ? <Loading/> :
          <>
          { selectingFilters && FilterSelectRow() }
            <PaginatedTable striped bordered hover
              thead={ <tr>
                <th style={{width : 20}}/>
                { TBD &&<th/>}
                <th style={{width : 125}}>ID</th>
                <th style={{width : 125}}>First Name</th>
                <th style={{width : 125}}>Last Name</th>
                <th style={{width : 200}}>Email</th>
                <th style={{width : 200}}>Club</th>
                <th style={{width : 200}}>Status</th>
                <th style={{width : 125}}>Fees</th>
                <th style={{width : 50}}/>
              </tr>}
              renderEmpty={<tr><td colSpan={9} style={{padding : 8 , textAlign : "center"}}>No Registered Coaches</td></tr>}
              renderRowAs={({item: coach})=>{
                return (
                    <tr key={coach.id}>
                        <td>
                          <div style={{display : "flex" , justifyContent : "center" , alignItems : "center"}}>
                            <VerifiedIcon className="mr-1" style={{color : coach.aab_verified ? "#007bff" : "#f16c2c"}}/>
                            <DollarIcon style={{color : coach.fees_paid ? "#007bff" : "#f16c2c"}}/>
                          </div>
                        </td>
                        { TBD &&<td><Form.Check type="checkbox"/></td>}
                        <td>{coach.id}</td>
                        <td>{coach.first_name}</td>
                        <td>{coach.last_name}</td>
                        <td>{coach.email}</td> 
                        <td>{coach.club.name}</td>
                        <td>
                          <div style={{display : "flex" ,alignItems : "center"}}>
                            <p className={`mr-1 mb-0`} style={{flexGrow : 2 , color : coach.aab_verified ? "#007bff" : "#f16c2c"}}>
                              {coach.aab_verified ? "Verified" : "Verification required"}
                            </p>
                            <OverlayTrigger placement="top" overlay={<Tooltip>{coach.aab_verified ? "UnVerify" : "Verify"}</Tooltip>}>
                                {
                                  coach.aab_verified ?
                                  <Button onClick={()=>handleUnVerifyClicked(coach.id)} size="sm" className="ml-1" variant={`outline-dark`}>
                                    <CloseIcon style={{fontSize :"1rem"}}/> 
                                  </Button> :
                                  <Button onClick={()=>handleVerifyClicked(coach.id)} size="sm" className="ml-1" variant={`outline-dark`}>
                                    <CheckIcon style={{fontSize :"1rem"}}/> 
                                  </Button>
                                }
                            </OverlayTrigger>
                          </div>
                        </td>
                        <td>
                          <div style={{display : "flex" , alignItems : "center"}}>
                            <p className={`mr-1 mb-0`}  style={{flexGrow : 2 , color : coach.fees_paid ? "#007bff" : "#f16c2c"}}>
                              {coach.fees_paid ? "Paid In Full" : "Due"  }
                            </p> 
                            <OverlayTrigger placement="top" overlay={<Tooltip>{coach.fees_paid ? "Reverse Payment" : "Confirm Payment"}</Tooltip>}>
                                {
                                  coach.fees_paid ?
                                <Button onClick={()=>handleUnpayFeesClicked(coach.id)} size="sm" className="ml-1" variant={`outline-dark`}>
                                  <CloseIcon style={{fontSize :"1rem"}}/>
                                </Button>  :
                                  <Button onClick={()=>handlePayFeesClicked(coach.id)} size="sm" className="ml-1" variant={`outline-dark`}>
                                    <CheckIcon style={{fontSize :"1rem"}}/> 
                                </Button> 
                                }
                            </OverlayTrigger>
                          </div>
                        </td>
                        <td style={{textAlign : "center"}}>
                          { TBD && <Button size="sm" className="ml-1" variant="outline-warning"><EditIcon style={{fontSize :"1rem"}}/></Button> }
                          <IconButton className="p-0 ml-1 text-danger"><DeleteIcon style={{fontSize :"1rem"}} onClick={()=>{setCoachToDelete(coach);setValidatingDelete(true)}}/></IconButton>
                          { TBD && <OverlayTrigger placement="top" overlay={<Tooltip>{coach.aab_verified ? "" : "Verify"}</Tooltip>}>
                            <Button onClick={()=>handleVerifyClicked(coach.id)} disabled={coach.aab_verified} size="sm" className="ml-1" variant="outline-primary"><VerifiedIcon style={{fontSize :"1rem"}}/></Button>
                            </OverlayTrigger>
                          }
                        </td>
                    </tr>
                )
                }}
              items={filtered_coaches}
              perPage={perPage}
              />
          </> 
        }

      {validatingDelete && coachToDelete &&
          <Modal show>
            <Modal.Header closeButton onHide={()=>setValidatingDelete(false)}>
                <Modal.Title>{`Delete Coach`}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>You have chosen to delete coach with <strong>{`${coachToDelete.first_name} ${coachToDelete.last_name}`}</strong>. This action cannot be undone.</p>
                <p>Do you wish to continue?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={()=>setValidatingDelete(false)}>
                  Close
                </Button>
                <Button variant="danger" onClick={handleCoachDelete}>Delete</Button>
              </Modal.Footer>
          </Modal>
    }
        </div>
    )
  }